import { PERMISSIONS, ADMIN_ROLE_EN } from '@bb8/config';

export default function (initialState: any) {
  const permission: string[] = initialState.currentUser?.permission ?? [];
  const role: string = initialState.currentUser?.role ?? ADMIN_ROLE_EN.ADMINISTRATOR;

  function judgePermission(key: string) {
    return Boolean(permission.find(p => p.startsWith(key))) || role === ADMIN_ROLE_EN.ADMINISTRATOR;
  }

  function judge(key: string) {
    return permission.includes(key) || role === ADMIN_ROLE_EN.ADMINISTRATOR;
  }

  function judgeHandle(key: string) {
    return judge(key) && role !== ADMIN_ROLE_EN.PREVIEW_STAFF;
  }

  return {
    administrator: role === ADMIN_ROLE_EN.ADMINISTRATOR,
    // 文件
    fileManage: initialState && initialState.currentUser ? [7, 8].includes(initialState.currentUser.userid) : false,
    // 流程
    workflowPreview: judgePermission('0-0'),
    workflowCreate: judgeHandle('0-0-1-0'),
    workflowEdit: judgeHandle('0-0-1-1'),
    workflowDelete: judgeHandle('0-0-1-2'),
    workflowCopy: judgeHandle('0-0-1-3'),
    workflowSave: judgeHandle('0-0-1-4'),
    // 链接
    linkPreview: judgePermission('0-2'),
    linkCreate: judgeHandle('0-2-1-0'),
    linkEdit: judgeHandle('0-2-1-1'),
    linkSave: judgeHandle('0-2-1-2'),

    // 小程序
    miniProgramPreview: judgePermission('0-1'),
    miniProgramCreate: judgeHandle('0-1-1-0'),
    miniProgramEdit: judgeHandle('0-1-1-1'),
    miniProgramSave: judgeHandle('0-1-1-2'),

    // 视频号
    channelPreview: judgePermission('0-3'),
    channelCreate: judgeHandle('0-3-1-0'),
    channelEdit: judgeHandle('0-3-1-1'),
    channelSave: judgeHandle('0-3-1-2'),

    // 小红书
    xiaohongshuPreview: judgePermission('1-0'),
    xiaohongshuCreate: judgeHandle('1-0-1-0'),
    xiaohongshuEdit: judgeHandle('1-0-1-1'),
    xiaohongshuSave: judgeHandle('1-0-1-2'),
    xiaohongshuRobot: judgeHandle('1-0-1-3'),

    xiaohongshuStorePreview: judgePermission('1-0'),

    xiaohongWorkerPreview: judgePermission('1-1'),
    xiaohongWorkerCreate: judgeHandle('1-1-1-0'),
    xiaohongWorkerEdit: judgeHandle('1-1-1-1'),
    xiaohongWorkerSave: judgeHandle('1-1-1-2'),

    // 权限管理
    wecomPreview: judgePermission('2-0') && role === ADMIN_ROLE_EN.ADMINISTRATOR,
    wecomEdit: judgeHandle('2-0-1-0'),
    wecomSave: judgeHandle('2-0-1-1'),

    // 知识库
    // 产品问答
    productQAPreview: judgePermission('3-0'),
    productQAEdit: judgeHandle('3-0-1-0'),
    productQASave: judgeHandle('3-0-1-1'),
    productQADelete: judgeHandle('3-0-1-2'),
    // 标签
    tagPreview: judgePermission('3-1'),
    tagEdit: judgeHandle('3-1-1-0'),
    tagSave: judgeHandle('3-1-1-1'),
    tagDelete: judgeHandle('3-1-1-2'),
  };
}
